<template>
  <ul class="ul_icons ul_bg">
    <li class="cloud_platform" v-for="item in blocks" :key="item.id" @click="toUrl(item)">
      <div class="">
        <img :src="item.bgimg" alt="" />
      </div>
      <span>
        <p>
          {{ item.title }}<br />
          <span v-html="item.bz"></span>
        </p>
      </span>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    blocks: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    toUrl(data) {
      window.open(data.tzurl)
    }
  },
  created() {},
  mounted() {}
}
</script>

<style>
</style>
